"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _withScopeId = n => ((0, vue_1.pushScopeId)("data-v-35275c8a"), n = n(), (0, vue_1.popScopeId)(), n);
const _hoisted_1 = { class: "detail-title" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_UpOutlined = (0, vue_1.resolveComponent)("UpOutlined");
    const _component_DownOutlined = (0, vue_1.resolveComponent)("DownOutlined");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("span", null, (0, vue_1.toDisplayString)(_ctx.title), 1),
        (_ctx.collapse !== undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                (_ctx.collapse === false)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_UpOutlined, {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.onCollapseChange()))
                    }))
                    : ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_DownOutlined, {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.onCollapseChange()))
                    }))
            ], 64))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
exports.render = render;
